import { Popover } from "@blueprintjs/core"
import { IMenuItem } from "@libs/interfaces/layouts"
import { CSSProperties, Fragment } from "react"
import HeaderMenuMainButton from "./HeaderMenuMainButton"
import HeaderMenuUnderButton from "./HeaderMenuUnderButton"

interface IProps {
    i: number
    item: IMenuItem
    isForceOpen?: boolean
    header_menu?: "inline" | "iconic"
    className?: string
    style?: CSSProperties
    pt?: string
    onRoute?: () => void
}
const HeaderUnderMenu = ({i, item, ...props}: IProps) :JSX.Element => {
    const onRoute = () => {
        if( props.onRoute) {
            props.onRoute()
        }
    }
 
    const children : JSX.Element[] | JSX.Element = Array.isArray(item.children)
        ?
        item.children.map((child: IMenuItem, i: number) => {
            return <HeaderMenuUnderButton 
                item={child} 
                key={i} 
                i={i} 
                parentRoute={ item.route }
                className={`${item.className || ""} `}
                onRoute={onRoute }
            />
        }) 
        :
        <div className="p-5">PODMENU</div> 
    return <Fragment>
        <Popover
            popoverClassName="p-0 menu-popover"
            className=" p-0 d-flex bg-dark-none "
            position="bottom-left"
            //usePortal={false}
            //enforceFocus
            interactionKind="hover"
            transitionDuration={ 50 }
            modifiers={{ arrow: { enabled: false } }}
            content={
                <div className=" podmenu-cont card2">
                    { children }
                </div>
            }
        >
            <HeaderMenuMainButton
                item={ item }
                i={ i }
                key={ i }
                onRoute={ onRoute }
                pt={props.pt}
                isForceOpen={props.isForceOpen}
                header_menu={props.header_menu}
                className={props.className}
            /> 
        </Popover>
    </Fragment>
} 
export default HeaderUnderMenu